// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"a3a559d2663dd9c2f7a8","45":"e1d7bac5a8dee5fda848","777":"0eeb4a136721bd182e78","972":"04a002743be0f6578fc9"}[chunkId] + ".js";
};